module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-37.5c53079c.png";